
import { Component, Inject, Injector} from "@angular/core";
import { GenericComponent } from '@shared/components/generic.component';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";

export interface ConfirmDialogData {
  title?: string;          
  message: string;         
  confirmText?: string;    
  cancelText?: string; 
}

@Component({
  selector: 'app-driveb-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  standalone: false
})
export class ConfirmModalComponent extends GenericComponent{

  constructor(
    injector: Injector,
    private dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    super(injector);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  closeDialog(onCancel?: boolean): void{
    if(onCancel){
      this.dialogRef.close(false)
    }
    else{
      this.dialogRef.close()
    }
  }
}
